import { createFileRoute } from '@tanstack/react-router';

import { getValorantPlayerOptions } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import { StatsStep } from '@/features/onboarding/components/steps/stats/statsStep';
import { getMyUserOptions } from '@/features/users/hooks/useGetMyUser/getMyUser.options';

export const Route = createFileRoute('/_protected/onboarding/_steps/stats')({
  loader: async ({ context }) => {
    const userResponse =
      await context.queryClient.ensureQueryData(getMyUserOptions());

    if (userResponse.user.riotPuuid) {
      await context.queryClient.ensureQueryData(
        getValorantPlayerOptions({ puuid: userResponse.user.riotPuuid }),
      );
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <StatsStep />;
}
